import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeysCopyToClipboard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 22,
	viewBox: "0 0 19 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		opacity: .8,
		x: -.5,
		y: .5,
		width: 13,
		height: 17,
		rx: 1.5,
		transform: "matrix(-1 0 0 1 14 3)",
		stroke: "#A3B8C2",
		strokeOpacity: .5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 1H16C16.5523 1 17 1.44772 17 2V10",
		stroke: "#A3B8C2",
		strokeOpacity: .5
	})]
});
export default SvgKeysCopyToClipboard;
